import React from 'react';

const AddToBoard = ({ handleClose, show, onSubmit, handleId, boards }) => {
  const showHideClassName = show ? 'modal show' : 'modal hide';

  return boards? (
    <div className={showHideClassName}>
      <div className="content add">
        <button className="close" onClick={handleClose}>
          <i className="fa fa-angle-right"></i>
          <i className="fa fa-angle-left"></i>
        </button>
        <form onSubmit={onSubmit}>
          <h3 className="title">Select a Group</h3>
          <div className="board-list">
          {boards.map((board, index) => (
            <div key={board.id} className="board-list-item">
              <label>
                <input type="radio" name="select-board" value={index} onChange={handleId} />
                <h3>{board.title}</h3>
              </label>
            </div>
          ))}
          </div>
          <p>
            <button className="btn" type="submit" >Add to Group</button>
          </p>
        </form>
      </div>
    </div>
  ) : <div></div>
}

export default AddToBoard;


// WEBPACK FOOTER //
// ./src/components/AddToBoard.js